import { useState, useEffect } from "react";
import useOrder from "../../../../hooks/data-hooks/admin/order/useOrder";
import Loader from "../../../common/components/loader/Loader";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { SearchIcon } from "../../../../utils/MyIcons";
import MessageItem from "./MessageItem";
import MessageBodyContent from "./MessageBodyContent";
import { useParams } from "react-router";
import { Helmet } from "react-helmet-async";

const Message = () => {
  const [selectedOrder, setSelectedOrder] = useState();

  const params = useParams();
  const {
    fetchChatMessage,
    orderList,
    isLoading,
    orderListError,
    chatList,
    isChatLoading
  } = useOrder(params?.id);

  useEffect(() => {
    fetchChatMessage();
  }, [params?.id]);

  const handleAddMessage = (message) => {
    setSelectedOrder(message);
    //console.log(message);
  };

  //  console.log(chatList);

  if (isLoading) return <Loader />;
  return (
    <div className="container">
      <Helmet>
        <title>Message | Admin | {process.env.REACT_APP_NAME}</title>
      </Helmet>
      <div className="border rounded d-flex shadow">
        <div className="my-2 w-33">
          <div className="p-3">
            <InputGroup className="mb-3 w-100 mx-auto">
              <Form.Control
                placeholder="search here"
                aria-label="Username"
                aria-describedby="basic-addon1"
              />
              <InputGroup.Text
                id="basic-addon1"
                className="bg-color text-white"
              >
                <span className="search-icon cursor-pointer ">
                  <SearchIcon />
                </span>
              </InputGroup.Text>
            </InputGroup>
          </div>
          {orderList?.map((messageItem) => (
            <MessageItem
              key={messageItem?._id}
              messageItem={messageItem}
              handleAddMessage={handleAddMessage}
              order={selectedOrder}
            />
          ))}
        </div>
        <div className="d-flex flex-column w-100 px-3 border-start">
          {isChatLoading ? (
            <Loader />
          ) : chatList?.length === 0 ? (
            <div className="w-100 h-100 d-flex align-items-center justify-content-center">
              No Chat
            </div>
          ) : (
            chatList?.map((message, index) => (
              <MessageBodyContent
                key={message?._id}
                message={message}
                previousMessage={chatList[index - 1]}
                currentIndex={index}
                count={chatList?.length}
              />
            ))
          )}
        </div>
        {/* <MessageBody
          messageBodyContents={selectedOrder}
          chatList={chatList?.data}
        /> */}
      </div>
    </div>
  );
};
export default Message;

{
  /* search-filed */
}
